import { render } from "./proposal-modal.vue?vue&type=template&id=6f1ee788&scoped=true"
import script from "./proposal-modal.vue?vue&type=script&lang=js"
export * from "./proposal-modal.vue?vue&type=script&lang=js"

import "./proposal-modal.vue?vue&type=style&index=0&id=6f1ee788&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f1ee788"]])

export default __exports__